import { MixinsOptions } from '@mui/material/styles/createMixins';

export const mixins: MixinsOptions = {};
